// extracted by mini-css-extract-plugin
export default {"button":"VTFwSR","container":"iBbAMO","descriptionHidden":"pTt_d5","mobileLink":"HW9U3d","expandedLink":"HwxQkL"};